module.exports = __webpack_public_path__ + "static/media/Kong_Ryman_IIIs_Katakomber.458440ba.md";